import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import config from './config.js';
import WidgetFrame from '../Utils/Widget/Frame/Frame.jsx';
import { appendSearchParamsFromQuery } from '../../utils/urlUtils.js';
import WidgetTitle, { ALIGN } from '../Utils/Widget/Title/Title.jsx';
import styles from './SubHierarchyInfoWidget.less';
import tracking from '../../tracking/tracking.js';
import { EXPAND_SEO_LINKS, EXPLORE_SEO_LINKS } from '../../tracking/trackingNaming.js';
import { Desktop, Mobile, Tablet } from '../Utils/MediaComponents/MediaComponents.tsx';
import TrackableLink from '../TrackableLink/TrackableLink';
import { getLocationQuery } from "../../selectors/selectors";


export class SubHierarchyInfoWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  renderLinks = (subHierarchyLinks, maxCollapsed) => {
    const { locationQuery } = this.props;

    return subHierarchyLinks.map((link, index) => {
      const hideClassName = index >= maxCollapsed ? 'hide' : '';
      const linkWithSearchParams = appendSearchParamsFromQuery(link.key, locationQuery);
      return (
        <li
          data-index={index}
          key={link.key}
          className={`grid-item one-fourth lap-one-half palm-one-whole padding-vertical-xs ${hideClassName}`}
        >
          <TrackableLink href={linkWithSearchParams} onClick={() => tracking.report(EXPLORE_SEO_LINKS)}>
            {link.name}
          </TrackableLink>
        </li>
      );
    });
  }

  onExpandHandler = () => {
    this.setState({ isExpanded: true });
    tracking.report(EXPAND_SEO_LINKS);
  };

  renderSubHierarchyLinks = (maxCollapsed) => {
    const { subHierarchyLinks } = this.props;
    const { isExpanded } = this.state;
    const shouldCollapse = subHierarchyLinks.length > maxCollapsed;

    return (
      <>
        <ul className="grid grid-flex">
          {this.renderLinks(subHierarchyLinks, isExpanded ? subHierarchyLinks.length : maxCollapsed)}
        </ul>
        {!isExpanded && shouldCollapse && (
          <div className="align-center padding-vertical-m">
            <button type="button" className={`link-text ${styles.expandAll}`} onClick={this.onExpandHandler}>
              <span className={`fa fa-angle-down fa-2x ${styles.downArrow}`} /> Alle {subHierarchyLinks.length} Adressen
              anzeigen
            </button>
          </div>
        )}
      </>
    );
  };

  render() {
    const { subHierarchyLinks, hierarchyLevel } = this.props;
    if (subHierarchyLinks.length === 0) return null;
    return (
      <WidgetFrame appearance="noPaddingNoShadowFrame">
        <div data-identifier="subHierarchyInfoWidget">
          <WidgetTitle
            id="sub-hierarchy-info"
            align={ALIGN.center}
            text={config.getTitleFor(hierarchyLevel)}
            subText=""
            useH3
          />
          <Mobile render={() => this.renderSubHierarchyLinks(5)} />
          <Desktop render={() => this.renderSubHierarchyLinks(12)} />
          <Tablet render={() => this.renderSubHierarchyLinks(8)} />
        </div>
      </WidgetFrame>
    );
  }
}

SubHierarchyInfoWidget.propTypes = {
  subHierarchyLinks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    }),
  ).isRequired,
  hierarchyLevel: PropTypes.string.isRequired,
  locationQuery: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  locationQuery: getLocationQuery(state),
});

export default connect(mapStateToProps)(SubHierarchyInfoWidget);
